import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/ABD-LOGO-1-e1739423897271.png"
              alt="Advanced Benefit Designs"
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`font-medium transition-colors ${
                scrolled ? 'text-slate-900 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              Home
            </Link>
            <a
              href="#services"
              className={`font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-slate-900 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              Services
            </a>
            <a
              href="#about"
              className={`font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-slate-900 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              About
            </a>
            <a
              href="https://community.advancedbenefitsdesigns.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className={`font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-slate-900 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              Community
            </a>
            <a
              href="#contact"
              className="px-6 py-2.5 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-slate-900 hover:bg-slate-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-slate-200 py-4 space-y-2">
            <Link
              to="/"
              className="block px-4 py-2 text-slate-900 hover:bg-slate-50 rounded-lg font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <a
              href="#services"
              className="block px-4 py-2 text-slate-900 hover:bg-slate-50 rounded-lg font-medium cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Services
            </a>
            <a
              href="#about"
              className="block px-4 py-2 text-slate-900 hover:bg-slate-50 rounded-lg font-medium cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              href="https://community.advancedbenefitsdesigns.com/login"
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-2 text-slate-900 hover:bg-slate-50 rounded-lg font-medium cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Community
            </a>
            <a
              href="#contact"
              className="block px-4 py-2 bg-teal-600 text-white rounded-lg font-semibold text-center cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact Us
            </a>
          </div>
        )}
      </div>

      {/* Top Bar - Only visible when not scrolled */}
      {!scrolled && (
        <div className="hidden lg:block bg-slate-900/50 backdrop-blur-sm border-b border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-2">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-6 text-slate-200">
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  <span>Doylestown, PA 18902</span>
                </div>
                <a href="mailto:support@advancedbenefitsdesigns.com" className="flex items-center gap-2 hover:text-teal-400 transition-colors">
                  <i className="ri-mail-line"></i>
                  <span>support@advancedbenefitsdesigns.com</span>
                </a>
                <a href="tel:215-262-5456" className="flex items-center gap-2 hover:text-teal-400 transition-colors">
                  <i className="ri-phone-line"></i>
                  <span>215-262-5456</span>
                </a>
              </div>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/share/1A2sciAZtx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 text-slate-200 hover:text-teal-400 transition-all cursor-pointer"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/advancedbenefitsdesigns/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 text-slate-200 hover:text-teal-400 transition-all cursor-pointer"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
